import { BCMSDefaultModel, BCMSRecord, StateManager, useBCMSContext, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import AddCardWrapper from "components/shared/containers/AddCardWrapper";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { UIPrimaryButton } from "components/ui/UIButton";
import Classes, { Card } from "model";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function UserRegistrationPage
 * @return {React.Component}
 * @exported true
 * @description The main component for UserRegistrationPage
 */

export default function UserRegistrationPage(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const defaultData = getDefaultData(context);
  const { goStep, state } = useWorkflow() ?? {};
  const navigate = useRoute();
  const data = { ...getDefaultData(context), ...state, ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    cancel: () => {
      navigate(`/home/recenttransactions/`);
    },

    done: () => {
      BCMSRecord.batch([
        Card.create(data.card)
      ], context, Classes);

      navigate(`/home/recenttransactions/`);
    },
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = controller => {
  const branding = controller.state.branding;
  const options = controller.state.branding.options;
  const card = options.include_debit_chw23 === "false"
      ? BCMSDefaultModel.creditCard()
      : BCMSDefaultModel.debitCard();
  card.number = "";
  card.expDatePlaceholder = "";
  card.id = Card.nextID();

  if(options.activate_card_chw23 === "false") {
      card.active = true;
  }

  return { 
    card,
    branding,
    code: "",
    street: "",
    zip: "",
  };
}

export const getDefaultUI = () => {

}

function PageContent(props) {
  const { data, update, cancel, done } = useStateManager();
  /*const workflowStep = useWorkflowStep(getDefaultCard, getWorkflowSteps);
  const card = workflowStep.read("card");

  const doneButton = evt => {
    BCMSRecord.batch([
      Card.create(card)
    ], workflowStep.globalController);

    workflowStep.navigate("/");
  };*/

  return (
    <AddCardWrapper className="user-registration-page">
      <MainContentContainer header={<MainContentHeader text="User Registration" showChevron={ false } />}>
      <div className="flex-container flex-vertical all-center-container user-registration-container">
        <div className="circle-icon">
            <div className="framed-icon-container">
                <SVGAsset id="OutlineCardIcon" />
                <SVGAsset id="CheckmarkCircleIcon" className="CheckmarkCircleIcon" />
            </div>
        </div>
        <b className="text-center card-added-text">Your card has been added</b>
        <p className="text-center">Card successfully added. It may take up to a minute to retrieve the associated accounts and details.</p>
        <UIPrimaryButton text="Done" onClick={ done } dataPoint="Card_Added_Done" />
      </div>
      
      </MainContentContainer>
    </AddCardWrapper>
  );
}
